import React from 'react';
import { CoverSlot } from './CoverSlot';
import { tomes, tomesTitle } from '../data/content';
export function Tomes() {
  return <section id="tomos" className="bg-ivory-deep text-ink" data-id="element-197" data-mp="1yrh9kgdjpqas">
      <div className="mx-auto max-w-content px-4 py-12 sm:px-6 lg:py-20" data-id="element-198" data-mp="1tzqtruvuaabz">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[1.55rem] font-semibold uppercase leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-199" data-mp="1txwb6n81iub2">
          <span className="block" data-id="element-200" data-mp="1l0c4uzvbm7tl">{tomesTitle.line1}</span>
          <span className="block text-terra-deep" data-id="element-201" data-mp="1g0r4qm4eztfa">{tomesTitle.line2}</span>
        </h2>

        <div className="mx-auto mt-8 grid max-w-5xl grid-cols-2 gap-x-4 gap-y-7 sm:gap-x-6 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-10" data-id="element-202" data-mp="1b1emkeohnaj1">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col" data-id="element-203" data-mp="1644knzjwx6eb">
              <div className="mx-auto w-full max-w-[13rem]" data-id="element-204" data-mp="35ecreirf5eyz">
                <CoverSlot kicker={tome.number} title={tome.title} image={tome.image} size="sm" data-id="element-205" data-mp="30gb8pyxwnho1" />
              </div>
              <div className="mx-auto mt-3.5 w-full max-w-[13rem] text-center sm:mt-4" data-id="element-206" data-mp="27gdycogcx4rx">
                <p className="font-sans text-[0.62rem] font-bold uppercase tracking-[0.16em] text-sage-deep sm:text-[0.68rem]" data-id="element-207" data-mp="2cfqk15vhs5sx">
                  {tome.number}
                </p>
                <h3 className="mt-1 font-display text-[0.92rem] font-semibold uppercase leading-tight text-ink sm:text-base" data-id="element-208" data-mp="1xl3wc0pykxe5">
                  {tome.title}
                </h3>
                <p className="mt-1.5 font-sans text-[0.8rem] leading-snug text-ink/75 sm:text-[0.88rem]" data-id="element-209" data-mp="2q86pedbv8fx0">{tome.phrase}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}